module.exports = __webpack_public_path__ + "img/img_82837_0_18.bf06312b.png";